// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-queue{height:25px;width:30px;margin:0 auto;display:flex;align-items:center;justify-content:center;background-color:var(--main-brand-color)}.order-queue.nextInLine{background-color:var(--brand-orange)}\n", ""]);
// Exports
module.exports = exports;
